import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export function ArticleCard({ article, index = 0, testid }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay: index * 0.06, ease: [0.16, 1, 0.3, 1] }}
    >
      <Link
        to={`/insights/${article.slug}`}
        data-testid={testid || `article-card-${article.slug}`}
        className="group block border-t border-white/15 pt-6"
      >
        <div className="overflow-hidden mb-6 aspect-[16/10]">
          <img
            src={article.cover_image || "https://images.unsplash.com/photo-1523477593243-78bbf626fd3b?crop=entropy&cs=srgb&fm=jpg&q=85"}
            alt={article.title}
            className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
          />
        </div>
        <div className="flex items-center gap-4 mb-3">
          <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-gold">{article.category}</span>
        </div>
        <h3 className="font-serif text-2xl md:text-3xl font-light leading-snug group-hover:text-gold transition-colors duration-300">
          {article.title}
        </h3>
        <p className="text-muted2 text-sm mt-3 leading-relaxed line-clamp-2">{article.excerpt}</p>
      </Link>
    </motion.div>
  );
}
